import {
  CLOSED_FILTER,
  VIEW_ALL_FILTER,
  ALL_CONTACTS_FILTER,
} from './constants';

const applyTermFilter = ({ caseNumber, rmaNumber, poNumber, items }, term) => {
  return term
    ? (caseNumber && caseNumber.includes(term)) ||
        (rmaNumber && rmaNumber.includes(term)) ||
        (poNumber && poNumber.includes(term)) ||
        (items && items.some(({ serialNumber }) => serialNumber.includes(term)))
    : true;
};

const applyContactFilter = (item, contactFilter) => {
  if (!contactFilter) {
    return true;
  }

  return contactFilter !== ALL_CONTACTS_FILTER
    ? item.contactName === contactFilter
    : true;
};

const applyStatusFilter = (item, statusFilter) => {
  if (!statusFilter) {
    return true;
  }

  return statusFilter !== VIEW_ALL_FILTER ? item.status === statusFilter : true;
};

const applyTabFilter = (item, tabFilter) => {
  if (!tabFilter) {
    return true;
  }

  const isItemClosed = item.status === CLOSED_FILTER;
  return !tabFilter || tabFilter === CLOSED_FILTER
    ? isItemClosed
    : !isItemClosed;
};

const applyFilters = ({
  items,
  term,
  contactFilter,
  statusFilter,
  tabFilter,
}) =>
  items.filter((rmaItem) => {
    return (
      applyTermFilter(rmaItem, term) &&
      applyContactFilter(rmaItem, contactFilter) &&
      applyStatusFilter(rmaItem, statusFilter) &&
      applyTabFilter(rmaItem, tabFilter)
    );
  });

export { applyFilters };
